import { render, staticRenderFns } from "./McpOauthAuthorizeView.vue?vue&type=template&id=1991fabd&scoped=true"
import script from "./McpOauthAuthorizeView.vue?vue&type=script&lang=js"
export * from "./McpOauthAuthorizeView.vue?vue&type=script&lang=js"
import style0 from "./McpOauthAuthorizeView.vue?vue&type=style&index=0&id=1991fabd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991fabd",
  null
  
)

export default component.exports